import { render, staticRenderFns } from "./i-binvoice.vue?vue&type=template&id=3e81f038&"
import script from "./i-binvoice.vue?vue&type=script&lang=js&"
export * from "./i-binvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports